import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function ProgramSection() {
  const ref1 = useScrollAnimation<HTMLDivElement>();
  const ref2 = useScrollAnimation<HTMLDivElement>();

  return (
    <>
      <section ref={ref1} className="scroll-animate bg-white py-8 md:py-12">
        <div className="flex items-center justify-center px-4 md:px-6">
          <img
            src="/media/img22.jpg"
            alt="레슨 프로그램"
            className="w-full h-auto max-w-full object-contain"
          />
        </div>
      </section>
      <section ref={ref2} className="scroll-animate bg-white py-8 md:py-12">
        <div className="flex items-center justify-center px-4 md:px-6">
          <img
            src="/media/img23.jpg"
            alt="레슨 프로그램"
            className="w-full h-auto max-w-full object-contain"
          />
        </div>
      </section>
    </>
  );
}